import ApiService from '@/common/api.service'

export default {
  findDataTax (radioParam, inputRoute, inputStation) {
    const formData = new FormData()
    formData.append('type', radioParam)
    formData.append('route', inputRoute)
    formData.append('station', inputStation)
    return new Promise((resolve, reject) => {
      ApiService.post('/inheritance-tax/list', formData).then(response => {
        resolve(response)
      }).catch(error => {
        reject(error)
      })
    })
  },
  finItemById (value) {
    return new Promise((resolve, reject) => {
      ApiService.query('/inheritance-tax/refer/' + value).then(response => {
        let arrayRespone = []
        arrayRespone.push(response.data.data)
        resolve(arrayRespone)
      }).catch(error => {
        reject(error)
      })
    })
  }
}
